/**
 * 复制文本到剪贴板 + toast 反馈 (报价单 / 提示词共用)。
 * navigator.clipboard 只在安全上下文 (https / localhost) 可用; 否则退回 execCommand("copy")。
 */
import { toast } from "@/components/ui";

export async function writeClipboard(text: string): Promise<boolean> {
  try {
    if (typeof navigator !== "undefined" && navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* 退回下面的旧方案 */
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

/** 复制并提示; 返回是否成功 */
export async function copyWithToast(text: string, what = "内容"): Promise<boolean> {
  const ok = await writeClipboard(text);
  if (ok) toast.success(`已复制${what}`);
  else toast.error("复制失败", { description: "浏览器不允许访问剪贴板, 请手动选择复制" });
  return ok;
}
